import React from "react";
import { BaseInput } from "./BaseInput";
import { WidgetProps } from "./models";

export const PasswordWidgetComponent = (props: WidgetProps<string | number>) => (
  <BaseInput type="password" {...props} />
);

export const PasswordWidget = PasswordWidgetComponent;
